import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { handleApiCall, RODEO_PAGE_NAME, URLS } from "src/_config";

interface LandingPageRedirectionProps {
  page: string;
}

const LandingPageRedirection = ({ page }: LandingPageRedirectionProps) => {
  const eventApi = useEventApi();
  const history = useHistory();
  const gameDetails = useAppGameDetailsSelector();

  const getGameDetails = () => {
    handleApiCall(eventApi.callGetGameDetails, null);
  };

  useEffect(() => {
    if (
      gameDetails?.show_landing_page == 1 &&
      gameDetails?.redirect_automatically != 1 &&
      page != RODEO_PAGE_NAME.TEAM_IMAGE
    ) {
      localStorage.removeItem("redirectedFromLanding");
      history.push(URLS.HOME);
      return;
    }
    if (
      gameDetails?.show_landing_page == 1 &&
      gameDetails?.redirect_automatically == 1 &&
      page != RODEO_PAGE_NAME.LANDING &&
      page != RODEO_PAGE_NAME.TEAM_IMAGE
    ) {
      const redirectedFromLanding = localStorage.getItem("redirectedFromLanding");
      if (!redirectedFromLanding) {
        history.push(URLS.HOME);
        return;
      }
    }
    if (gameDetails?.show_landing_page == 0) {
      localStorage.removeItem("redirectedFromLanding");
    }
  }, [gameDetails]);

  useEffect(() => {
    getGameDetails();
  }, []);

  return <></>;
};

export default LandingPageRedirection;
